module.exports = __webpack_public_path__ + "img/cf5aa5bd-01d6-496d-a0ff-fd7c76b90a44.f2d0d080.png";